// src/admin/pages/AdminSaleProducts.js
import AdminProductsBase from "./AdminProductsBase";
import { useNavigate } from "react-router-dom";

export default function AdminSaleProducts() {
  const navigate = useNavigate();

  return (
    <AdminProductsBase
      filterType="sale"
      rightAction={
  <div className="flex gap-2">
    <button
      onClick={() => navigate("/admin/products/make-sale")}
      className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-xl font-semibold"
    >
      Make a Sale
    </button>

    <button
      onClick={() => navigate("/admin/products/remove-sale")}
      className="bg-gray-800 hover:bg-black text-white px-4 py-2 rounded-xl font-semibold"
    >
      Remove Sale
    </button>
  </div>
}
    />
  );
}

